"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentHttpClient = void 0;
var cross_fetch_1 = __importDefault(require("cross-fetch"));
var get_context_1 = require("../utils/get-context");
var SegmentHttpClient = /** @class */ (function () {
    function SegmentHttpClient(segmentWriteKey, analyticsClient) {
        this.analyticsClient = analyticsClient;
        this.baseUrl = 'https://api.segment.io/v1';
        this.headers = {
            'Content-Type': 'application/json',
            Authorization: "Basic ".concat(btoa(segmentWriteKey + ':')),
        };
    }
    SegmentHttpClient.prototype.track = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = event;
                        return [4 /*yield*/, this.getDefaultOptions(event.segmentOptions)];
                    case 1:
                        _a.segmentOptions = _b.sent();
                        return [4 /*yield*/, this.sendRequest('/track', __assign({ event: event.eventName, properties: event.properties }, event.segmentOptions))];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SegmentHttpClient.prototype.identify = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = event;
                        return [4 /*yield*/, this.getDefaultOptions(event.segmentOptions, false)];
                    case 1:
                        _a.segmentOptions = _b.sent();
                        return [4 /*yield*/, this.sendRequest('/identify', __assign({ userId: event.userId, traits: event.traits }, event.segmentOptions))];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SegmentHttpClient.prototype.page = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = event;
                        return [4 /*yield*/, this.getDefaultOptions(event.segmentOptions)];
                    case 1:
                        _a.segmentOptions = _b.sent();
                        return [4 /*yield*/, this.sendRequest('/page', __assign({ name: event.name, category: event.category, properties: event.properties }, event.segmentOptions))];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SegmentHttpClient.prototype.sendRequest = function (endpoint, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, cross_fetch_1.default)("".concat(this.baseUrl).concat(endpoint), {
                            method: 'POST',
                            headers: this.headers,
                            body: JSON.stringify(data),
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("HTTP error! Status: ".concat(response.status));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Adds anonymousId and userId (optionally) to the SegmentOptions object.
     *
     * @param data - The SegmentOptions object to add the IDs to.
     * @param includeUserId - Whether to include the userId in the options.
     * @returns The updated SegmentOptions object with the added IDs.
     */
    SegmentHttpClient.prototype.addIdsToEvent = function (data, includeUserId) {
        var _a;
        if (data === void 0) { data = {}; }
        if (includeUserId === void 0) { includeUserId = true; }
        return __awaiter(this, void 0, void 0, function () {
            var anonymousId, userId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.analyticsClient.getAnonymousId()];
                    case 1:
                        anonymousId = (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.toString();
                        if (anonymousId && !data.anonymousId) {
                            data.anonymousId = anonymousId;
                        }
                        if (!includeUserId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.analyticsClient.getUserId()];
                    case 2:
                        userId = _b.sent();
                        if (userId && !data.userId) {
                            data.userId = userId;
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Prepares default Segment options by adding IDs and context information.
     *
     * @param data - Initial SegmentOptions to merge with the defaults.
     * @param includeUserId - Whether to include the userId in the options.
     * @returns The updated SegmentOptions object with defaults applied.
     */
    SegmentHttpClient.prototype.getDefaultOptions = function (data, includeUserId) {
        if (data === void 0) { data = {}; }
        if (includeUserId === void 0) { includeUserId = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addIdsToEvent(data, includeUserId)];
                    case 1:
                        data = _a.sent();
                        data.context = __assign(__assign({}, (0, get_context_1.getDefaultContext)()), data.context);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return SegmentHttpClient;
}());
exports.SegmentHttpClient = SegmentHttpClient;
